import axios from "axios";
import { API_HOST } from "../../api_utils";

export const deleteDataModels = async (id, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.delete(
    `${API_HOST}customroutes/models/${id}`,
    config
  );
  return response.data;
};